import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { GridModule } from "@syncfusion/ej2-angular-grids";
import { MyDatePickerModule } from "mydatepicker";
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { MaskedTextBoxModule } from "@syncfusion/ej2-angular-inputs";
import { AdminTimeComponent } from "./admin-time.component";
import { AdminTimeEditComponent } from "./admin-time-edit/admin-time-edit.component";
import { AdminTimeListComponent } from "./admin-time-list/admin-time-list.component";
import { AdminTimeRoutingModule } from "./admin-time-routing.module";
@NgModule({
  declarations: [
    AdminTimeEditComponent,
    AdminTimeListComponent,
    AdminTimeComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    GridModule,
    MyDatePickerModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    AdminTimeRoutingModule,
  ],
})
export class AdminTimeModule {}
